import ReCaptchaTypes from '../../enums/ReCaptchaTypes';
import {SET_RECAPTCHA_STRATEGY, SET_RECAPTCHA_TOKEN} from '../actions/action-types';

export const initialState = {
  recaptchaStrategy: ReCaptchaTypes.DISABLED,
  token: '',
};

const recaptchaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RECAPTCHA_STRATEGY:
      return {
        ...state,
        recaptchaStrategy: action.strategy,
      };
    case SET_RECAPTCHA_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    default:
      return state;
  }
};

export default recaptchaReducer;
